/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Handle, Position } from '@xyflow/react';
import CloseIcon from '@mui/icons-material/Close';
import { SidePopover } from '../../../globalUtils/globalExports';

import './RemoteCommandNode.css'
import { ExecutionPlan, RemoteCommandAction } from './ExecutionPlan';
import { IconWithTooltip } from '../../../globalUtils/globalIcons';
import RemoteCommandSidePopover from './RemoteCommandSidePopover';


interface CustomNodeProps {
    data: {
        actionButtonVisible: string,
        addNodeToCanvas,
        addIcon: boolean;
        executionPlan: ExecutionPlan;
        handleUpdateExecutionPlan: Function;
        ifOrElse: string;
        removeNode: Function;
        nodeId: string;
        typeOfNode: string;
        parentNodeId: string;
    };
}


const RemoteCommandNode: React.FC<CustomNodeProps> = ({ data }: CustomNodeProps) => {

    const [isRemoteCommandPopoverOpen, setIsRemoteCommandPopoverOpen] = useState(false);
    const [remoteCommand, setRemoteCommand] = useState<RemoteCommandAction | null>(null);


    const handleEditClick = () => {
        setIsRemoteCommandPopoverOpen(true);
    };

    const handleCloseRemoteCommandPopover = () => {
        setIsRemoteCommandPopoverOpen(false);
    }

    useEffect(() => {
        const currentRemoteCommand = data?.executionPlan?.actions?.find((executionPlanItem) => executionPlanItem.flowType === data?.ifOrElse && executionPlanItem?.parentNodeId === data?.parentNodeId)?.list?.find((executionPlanAction) => executionPlanAction.type === 'Remote Command') as RemoteCommandAction;
        if (currentRemoteCommand) {
            setRemoteCommand(currentRemoteCommand)
        }
    }, [data?.executionPlan])


    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                <Paper
                    elevation={3}
                    sx={{
                        border: '1px solid #0080DC',
                        borderLeft: '6px solid #0080DC',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        minWidth: '350px',
                        backgroundColor: '#fff',
                        position: 'relative',
                        marginBottom: '16px',
                        minHeight: '110px'
                    }}
                >
                    <IconButton
                        size="small"
                        onClick={() => {
                            if (data?.removeNode) {
                                data.removeNode(data?.nodeId);
                            }
                        }}
                        sx={{ position: 'absolute', top: 0, right: 0 }}
                    >
                        <CloseIcon fontSize="small" sx={{ color: '#666' }} />
                    </IconButton>
                    <Handle type="target" className="transparent-handle" position={Position.Left} id='left' />
                    <Handle type="source" position={Position.Bottom} className='transparent-handle' />
                    <Handle type="source" position={Position.Left} className='transparent-handle' id='left' />
                    <Box display="flex" alignItems="center" marginBottom="8px">
                        <IconWithTooltip iconClassName={'remote-command-sidebar-1'} />
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 600,
                                fontSize: '1rem',
                            }}
                        >
                            {'Remote Command'}
                        </Typography>
                    </Box>

                    {/* Category and Sub Category */}
                    <Box
                        sx={{
                            backgroundColor: '#f0f4ff',
                            padding: '8px',
                            borderRadius: '10px',
                            position: 'relative',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'

                        }}
                    >
                        {/* <Box display="flex" flexDirection="column" alignItems="start" justifyContent="center"> */}
                            <Box display="flex" alignItems="center">
                                <FiberManualRecordIcon fontSize="small" sx={{ color: '#4a90e2', fontSize: '0.75rem', marginRight: '4px' }} />
                                <Typography variant="body2" sx={{ fontSize: '0.875rem', color: '#666' }}>
                                    Remote Command: <strong>{remoteCommand && remoteCommand?.remoteCommandType && <span>{remoteCommand?.remoteCommandType.toUpperCase()}</span>}</strong>
                                </Typography>
                            </Box>
                        {/* </Box> */}
                        <IconButton
                            size="small"
                            onClick={handleEditClick}

                        >
                            <EditIcon fontSize="small" sx={{ color: '#666' }} />
                        </IconButton>
                    </Box>

                    {/* Add Activity link */}
                </Paper>
                {data.actionButtonVisible &&
                    <Typography
                        onClick={() => data.addNodeToCanvas()}
                        variant="body2"
                        sx={{
                            color: '#B0B1B6',
                            marginTop: '8px',
                            marginLeft: '10px',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                        }}
                    >
                        + Add Activity
                    </Typography>
                }
            </div>
            {isRemoteCommandPopoverOpen && <SidePopover
                id='advance__rule__engine__execution__plan__action__control__remote__command__popover'
                open={isRemoteCommandPopoverOpen}
                headerText={`Action Control - ${data.ifOrElse === 'If' ? 'Then' : 'Else'}`}
                containerClassName='advance__rule__engine__detail__popover'
                handleClose={() => { }}
                headerSecondaryText={'Remote Command'}
                horizontalLinePopover={true}
                popperClassName='advance__rule__engine__remote__command__popper'
                headerClassName={'advance__rule__engine__header__config'}
                isRuleEnginePopOver={true}
                subHeadingIconClassName={'remote-command-sidebar'}
                ruleEngineSidePopoverOnclose={handleCloseRemoteCommandPopover}
                // eslint-disable-next-line react/no-children-prop
                children={
                    <>
                        {
                            <RemoteCommandSidePopover
                                remoteCommand={remoteCommand ?? null}
                                handleClose={handleCloseRemoteCommandPopover}
                                executionPlan={data?.executionPlan}
                                handleUpdateExecutionPlan={data?.handleUpdateExecutionPlan}
                                ifOrElse={data?.ifOrElse ?? ''}
                                nodeId={data?.nodeId}
                                parentNodeId = {data?.parentNodeId}
                            />
                        }
                    </>
                }
            />
            }

        </>

    );
};

export default RemoteCommandNode;
